/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  MonthPlanStateIncomeTypeDto,
  MonthPlanStateIncomeTypeDtoFromJSON,
  MonthPlanStateIncomeTypeDtoFromJSONTyped,
  MonthPlanStateIncomeTypeDtoToJSON,
} from "./MonthPlanStateIncomeTypeDto";
import {
  MonthPlanStateWeekItemDto,
  MonthPlanStateWeekItemDtoFromJSON,
  MonthPlanStateWeekItemDtoFromJSONTyped,
  MonthPlanStateWeekItemDtoToJSON,
} from "./MonthPlanStateWeekItemDto";

/**
 *
 * @export
 * @interface MonthPlanStateVariableCostIncomeDto
 */
export interface MonthPlanStateVariableCostIncomeDto {
  /**
   *
   * @type {string}
   * @memberof MonthPlanStateVariableCostIncomeDto
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof MonthPlanStateVariableCostIncomeDto
   */
  plan: number;
  /**
   *
   * @type {number}
   * @memberof MonthPlanStateVariableCostIncomeDto
   */
  percent: number;
  /**
   *
   * @type {number}
   * @memberof MonthPlanStateVariableCostIncomeDto
   */
  fact: number;
  /**
   *
   * @type {MonthPlanStateIncomeTypeDto}
   * @memberof MonthPlanStateVariableCostIncomeDto
   */
  incomeType: MonthPlanStateIncomeTypeDto;
  /**
   *
   * @type {Array<MonthPlanStateWeekItemDto>}
   * @memberof MonthPlanStateVariableCostIncomeDto
   */
  weeks: Array<MonthPlanStateWeekItemDto>;
}

export function MonthPlanStateVariableCostIncomeDtoFromJSON(json: any): MonthPlanStateVariableCostIncomeDto {
  return MonthPlanStateVariableCostIncomeDtoFromJSONTyped(json, false);
}

export function MonthPlanStateVariableCostIncomeDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonthPlanStateVariableCostIncomeDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    plan: json["plan"],
    percent: json["percent"],
    fact: json["fact"],
    incomeType: MonthPlanStateIncomeTypeDtoFromJSON(json["incomeType"]),
    weeks: (json["weeks"] as Array<any>).map(MonthPlanStateWeekItemDtoFromJSON),
  };
}

export function MonthPlanStateVariableCostIncomeDtoToJSON(value?: MonthPlanStateVariableCostIncomeDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    plan: value.plan,
    percent: value.percent,
    fact: value.fact,
    incomeType: MonthPlanStateIncomeTypeDtoToJSON(value.incomeType),
    weeks: (value.weeks as Array<any>).map(MonthPlanStateWeekItemDtoToJSON),
  };
}
